import { render, staticRenderFns } from "./TicketingTabProcessing.vue?vue&type=template&id=b824d1ca&scoped=true"
import script from "./TicketingTabProcessing.vue?vue&type=script&lang=js"
export * from "./TicketingTabProcessing.vue?vue&type=script&lang=js"
import style0 from "./TicketingTabProcessing.vue?vue&type=style&index=0&id=b824d1ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b824d1ca",
  null
  
)

export default component.exports